/**
 * Created By: Tyrus Malmstrom
 * Creation Date: 05/19/2022
 * Description:
 *   - Global vue component that handles the logic of watching the users network status -- alerting them if they have
 *     lost connection or not.
*/

import component from './Offline.vue';

const install = (Vue) => {
  if (install.installed) return;
  install.installed = true;
  Vue.component('PlaypositOffline', component);
};

const plugin = {
  install,
};

let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

component.install = install;

// export Offline component by default
export default component;